/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M81.25 53.125H21.875a3.124 3.124 0 1 1 0-6.25H81.25a3.124 3.124 0 1 1 0 6.25z"/><path pid="1" d="M59.375 78.125a3.127 3.127 0 1 1-2.344-5.188L77.093 50 57.031 27.06a3.12 3.12 0 0 1 .371-4.304 3.122 3.122 0 0 1 4.317.18l21.875 25a3.128 3.128 0 0 1 0 4.124l-21.875 25a3.117 3.117 0 0 1-2.344 1.063z"/>'
  }
})
